import React from 'react';
import { Image, Row, Col, Container } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-regular-svg-icons';
import { faMobileAlt } from '@fortawesome/free-solid-svg-icons';

let rightDiv = {
    marginTop: '25px'
}

let imgLogo = {
    height: '100px'
}

function Loginheader() {
    return (
        <>
            <div >
                <Container >
                    <Row>
                        <Col>
                            <Image style={imgLogo} src="img/zenith-e-remit.png" fluid />
                        </Col>
                        <Col>
                            <div className="divContentRight" style={rightDiv}>
                                <ul style={{ listStyleType: 'none' }}>
                                    <li><FontAwesomeIcon icon={faEnvelope} />&nbsp;support@zenithforex.com<br></br> </li>
                                    <li><FontAwesomeIcon icon={faMobileAlt} />&nbsp;98705&nbsp;66055</li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </div>
        </>
    );
}
export default Loginheader;